import type { NextPage } from 'next';

import {
	InPageNavigationBlock,
	InPageNavigationBlockProps,
} from '@web/blocks/in-page-navigation-block/in-page-navigation-block';

import { HeroBlock } from '@web/components/hero-block/hero-block';

import TemplateLayout from '@web/layouts/template/template';

import { getBlockFixture } from '@web/services/umbraco/__fixtures__/block.fixture';
import { UmbracoPage } from '@web/services/umbraco/types/documents/UmbracoDocument';
import { HeroBlockType } from '@web/services/umbraco/types/elements/Hero';

export const contentAlias = 'transportPage';

export type TransportPageData = UmbracoPage<
	typeof contentAlias,
	{
		hero: HeroBlockType;
		headerDisabled: boolean;
	},
	{
		children: UmbracoPage<string, { hero: HeroBlockType }>[];
	}
>;

const TransportPageTemplate: NextPage<{ pageData: TransportPageData }> = ({ pageData }) => {
	const inpageBlockData: InPageNavigationBlockProps['block'] = getBlockFixture('inPageNavigationBlock', {
		title: pageData.properties.headerDisabled ? undefined : 'Vælg din situation',
		prefixTitle: '',
		pages: pageData.children,
		showTitleInline: 'titleInlineFalse',
	});

	return (
		<TemplateLayout>
			{pageData.properties.hero && <HeroBlock block={pageData.properties.hero} />}

			<InPageNavigationBlock block={inpageBlockData} />
		</TemplateLayout>
	);
};

export default TransportPageTemplate;
